export const preventCanvasBubbling = (e: any) => {
    e.stopPropagation();
};
